// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select {
    position: relative;
    font-family: Arial;
}

.custom-select div,.select-selected {
    color: #ffffff;
    padding: 8px 16px;
    border: 1px solid transparent;
    border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
    cursor: pointer;
}
  
.custom-select select {
    display: none; /*hide original SELECT element: */
}
  
.select-selected {
    background-color: DodgerBlue;
}
  
  /* Style the arrow inside the select element: */
.select-selected:after {
    position: absolute;
    content: "";
    top: 14px;
    right: 10px;
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-color: #fff transparent transparent transparent;
}
  
  /* Point the arrow upwards when the select box is open (active): */
.select-selected.select-arrow-active:after {
    border-color: transparent transparent #fff transparent;
    top: 7px;
}
  
  /* style the items (options), including the selected item: */
.select-items div,.select-selected {
    color: #ffffff;
    padding: 8px 16px;
    border: 1px solid transparent;
    border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
    cursor: pointer;
}
  
  /* Style items (options): */
.select-items {
    position: absolute;
    background-color: DodgerBlue;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 99;
}
  
  /* Hide the items when the select box is closed: */
.select-hide {
    display: none;
}
  
.select-items div:hover, .same-as-selected {
    background-color: rgba(0, 0, 0, 0.1);
}

.form-error {
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Signup/Register.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,oEAAoE;IACpE,eAAe;AACnB;;AAEA;IACI,aAAa,EAAE,iCAAiC;AACpD;;AAEA;IACI,4BAA4B;AAChC;;EAEE,+CAA+C;AACjD;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,sDAAsD;AAC1D;;EAEE,kEAAkE;AACpE;IACI,sDAAsD;IACtD,QAAQ;AACZ;;EAEE,4DAA4D;AAC9D;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,oEAAoE;IACpE,eAAe;AACnB;;EAEE,2BAA2B;AAC7B;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;AACf;;EAEE,kDAAkD;AACpD;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".custom-select {\n    position: relative;\n    font-family: Arial;\n}\n\n.custom-select div,.select-selected {\n    color: #ffffff;\n    padding: 8px 16px;\n    border: 1px solid transparent;\n    border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;\n    cursor: pointer;\n}\n  \n.custom-select select {\n    display: none; /*hide original SELECT element: */\n}\n  \n.select-selected {\n    background-color: DodgerBlue;\n}\n  \n  /* Style the arrow inside the select element: */\n.select-selected:after {\n    position: absolute;\n    content: \"\";\n    top: 14px;\n    right: 10px;\n    width: 0;\n    height: 0;\n    border: 6px solid transparent;\n    border-color: #fff transparent transparent transparent;\n}\n  \n  /* Point the arrow upwards when the select box is open (active): */\n.select-selected.select-arrow-active:after {\n    border-color: transparent transparent #fff transparent;\n    top: 7px;\n}\n  \n  /* style the items (options), including the selected item: */\n.select-items div,.select-selected {\n    color: #ffffff;\n    padding: 8px 16px;\n    border: 1px solid transparent;\n    border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;\n    cursor: pointer;\n}\n  \n  /* Style items (options): */\n.select-items {\n    position: absolute;\n    background-color: DodgerBlue;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 99;\n}\n  \n  /* Hide the items when the select box is closed: */\n.select-hide {\n    display: none;\n}\n  \n.select-items div:hover, .same-as-selected {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n.form-error {\n  color: red;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
